// export const SERVER_URL = 'http://localhost:5000/';
// export const SERVER_URL = 'https://fast-reaches-40751.herokuapp.com/';
// export const SERVER_URL = 'http://35.217.41.219:5000/';
export const SERVER_URL = 'https://poker-planning-server.herokuapp.com/';
